"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShowQuickBuyButton = void 0;
var _mapCanBeSold = require("./mapCanBeSold");
var _mapHasAutoSubscription = require("./mapHasAutoSubscription");
/**
 * Determines if the quick buy button should be shown.
 * Shown if the product can be sold, has at least one shades that can be sold or has auto subscription.
 *
 * @param labels
 * @param shades
 */
const mapShowQuickBuyButton = labels => {
  const canBeSold = (0, _mapCanBeSold.mapCanBeSold)(labels);
  const hasAutoSubscription = (0, _mapHasAutoSubscription.mapHasAutoSubscription)(labels);
  return canBeSold || hasAutoSubscription;
};
exports.mapShowQuickBuyButton = mapShowQuickBuyButton;
//# sourceMappingURL=mapShowQuickBuyButton.js.map